import { render, staticRenderFns } from "./EmailTemplateCardSkeleton.vue?vue&type=template&id=7141b2a2&scoped=true&"
import script from "./EmailTemplateCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateCardSkeleton.vue?vue&type=style&index=0&id=7141b2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7141b2a2",
  null
  
)

export default component.exports